import MyAppointmentsPage from './MyAppointmentsPage';
export default MyAppointmentsPage